import { Box, Breadcrumbs, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Link,useParams } from 'react-router-dom'
import {getUser} from '../../api/APIServices';
import { API_STATUS, BASE_URL } from '../../constants';
import Summary from './Summary';
import Notes from './Notes';
import UserCheckList from './UserCheckList'
import Performance from './Performance';
import { resetUser } from '../../redux/slices/userSlice';
import { resetPerformance } from '../../redux/slices/performanceSlice';

function UserDetails() {
    const {t} = useTranslation('global');
    const params = useParams();
    const dispatch = useDispatch();

    const userId = params.userId ? params.userId : null;
    const {status, data, compliance, notes, intakeCheckList} = useSelector((state) => state.user);

    useEffect(()=> {
        if(userId) {
            dispatch(getUser(userId));
        }
        return ()=> {
            console.log('reset USER')
            dispatch(resetUser());
            dispatch(resetPerformance());
        }
    },[]);

    useEffect(() => {
        if(userId && intakeCheckList) {
            dispatch(getUser(userId));
        }
    },[intakeCheckList])
 
  return (
    <div>
        <div className='full-container'>
            <div style={{margin: '0px 10px'}}>
                <Breadcrumbs aria-label="breadcrumb" className='breadcrum'>
                    <Link underline="hover" color="inherit"  to="/users">
                        Users
                    </Link>
                    <Typography color="text.primary" className='breadcrum'>Summary</Typography>
                </Breadcrumbs>
            </div>
            {status === API_STATUS.PENDING && <>{t('loading')}.</>}
            {status && status === API_STATUS.SUCCESS && <>
                <Box sx={{padding:'5px 10px', backgroundColor:'aliceblue', borderRadius:'10px'}}>
                  
                    {data && <Summary data={data} compliance={compliance} />}
                </Box>
                {data && ("intakeDate" in data)  && 
                    <div style={{margin:'10px 5px', borderRadius:'5px', position: 'relative', border:'1px solid #ccc'}}>
                        <Box >
                            {performance && <Performance data={data} />}
                            {notes && <Notes notes={notes} />}
                        </Box>
                    </div>
                }
                
                <Box sx={{padding:'0px 10px'}}> 
                    {data && !("intakeDate" in data)  && 
                        <UserCheckList />
                    }
                </Box>
                                        
            </>}
        </div>
    </div>
  )
}

export default UserDetails